import RepPlans from './RepPlans';
import RepDetailsForm from './RepDetailsForm';
import Details from './Details';

const RepDetails = () => {
  return (
    <div>
      <RepDetailsForm />
      <Details />
      <RepPlans />
    </div>
  );
};

export default RepDetails;
